module.exports = "<div class=sticker-image hm-tap=$ctrl.AppServices.PixiManager.addSticker($ctrl.options) style=background-image:url({{$ctrl.AppServices.DataManager.config.settings.assetsPath}}{{$ctrl.options.image}})></div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/sticker-image/sticker-image.html
 ** module id = 78
 ** module chunks = 0
 **/